import { TableCell, TableRow } from "@mui/material";
import EntityDeleteToggleButton from "../../../Projects/ProjectDetails/components/ToolDeleteToggleButton/EntityDeleteToggleButton";
import styles from "./ProjectUserTableRow.module.scss";
import ProjectUserDetailsFieldsTableRow from "../ProjectUserDetailsFieldsTableRow/ProjectUserDetailsFieldsTableRow";
import { UseFormReturn } from "react-hook-form";
import { ProjectFormType } from "../../hooks/useCreateProject";
import GridTools from "../../../Projects/ProjectsList/components/GridTools/GridTools";
import { ToolCapability, User } from "../../models/FormModels";
import { CapabilityTool } from "../../models/tools";
import { Roles } from "../../models/roles";
import { EntityState } from "../../api/models/EntityState";
import { mapBackendRoleToDisplay } from "../../utils/roleMapping";

interface ProjectUserTableRowProps {
  form: UseFormReturn<ProjectFormType>;
  userOpen: boolean;
  user: User;
  rowIndex: number;
  userCanEdit: boolean;
  handleDelete: (index: number) => void;
  ToggleItemButton: React.ReactNode;
  packageId: string;
  useCustomRoleMapping: boolean;
  isCreateMode?: boolean;
}

const ProjectUserTableRow = ({
  form,
  userOpen,
  user,
  rowIndex,
  userCanEdit,
  handleDelete,
  ToggleItemButton,
  packageId,
  useCustomRoleMapping,
  isCreateMode = false,
}: ProjectUserTableRowProps): JSX.Element => {
  
  const toolCaps = form.watch(`users.${rowIndex}.toolCaps`) || user.toolCaps;
  const roles = form.watch(`users.${rowIndex}.roles`) || user.roles;
  
  const getGridTools = (toolsCaps: ToolCapability[]) => {
    return toolsCaps
      .filter((tc) => tc.hasAccess)
      .map((tc) => {
        return tc.capabilityToolKey as CapabilityTool;
      });
  };

  const getRolesLabel = (roles: Roles[]) => {
    // Use useCustomRoleMapping flag to determine if role mapping is needed
    const displayRoles = roles.map(role => {
      const roleString = role.toString();
      return useCustomRoleMapping ? mapBackendRoleToDisplay(roleString, packageId) : roleString;
    });
    
    return displayRoles.length > 1 ? "Multiple" : displayRoles[0];
  };

  return (
    <>
      <TableRow>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {user.name}
          </div>
        </TableCell>
        <TableCell> {user.adPrinciple}</TableCell>
        <TableCell> {user.email}</TableCell>
        <TableCell>{getRolesLabel(roles)}</TableCell>
        <TableCell>
          <GridTools tools={getGridTools(toolCaps as ToolCapability[])} />
        </TableCell>
        <TableCell sx={{ p: 0, pl: 2, height: "100%" }}>
          <div className={styles.userDetails__collapseCell}>
            <div>
              {userCanEdit && (
                <EntityDeleteToggleButton
                  entityName={"user"}
                  entityStatus={user.editStatus as EntityState}
                  onClick={() => handleDelete(rowIndex)}
                />
              )}
            </div>
            {ToggleItemButton}
          </div>
        </TableCell>
      </TableRow>
      <ProjectUserDetailsFieldsTableRow
        form={form}
        userOpen={userOpen}
        index={rowIndex}
        userCanEdit={userCanEdit}
        useCustomRoleMapping={useCustomRoleMapping}
        isCreateMode={isCreateMode}
        isEdit
      />
    </>
  );
};

export default ProjectUserTableRow;
